/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetQrCodeQuery } from '../models/get-qr-code-query';
import { QrCodeModel } from '../models/qr-code-model';
import { QrCodeUserInfoModel } from '../models/qr-code-user-info-model';

@Injectable({
  providedIn: 'root',
})
export class QrCodeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * Path part for operation getQrCode
   */
  static readonly GetQrCodePath = '/api/qrcode';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQrCode$Response(params?: { query?: GetQrCodeQuery; context?: HttpContext }): Observable<StrictHttpResponse<QrCodeModel>> {
    const rb = new RequestBuilder(this.rootUrl, QrCodeService.GetQrCodePath, 'get');
    if (params) {
      rb.query('query', params.query, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<QrCodeModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQrCode(params?: { query?: GetQrCodeQuery; context?: HttpContext }): Observable<QrCodeModel> {
    return this.getQrCode$Response(params).pipe(map((r: StrictHttpResponse<QrCodeModel>) => r.body as QrCodeModel));
  }

  /**
   * Path part for operation getUserInfoFromQrCode
   */
  static readonly GetUserInfoFromQrCodePath = '/api/qrcode/userinfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserInfoFromQrCode()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfoFromQrCode$Response(params?: {
    qrCodeData?: string;
    context?: HttpContext;
  }): Observable<StrictHttpResponse<QrCodeUserInfoModel>> {
    const rb = new RequestBuilder(this.rootUrl, QrCodeService.GetUserInfoFromQrCodePath, 'get');
    if (params) {
      rb.query('qrCodeData', params.qrCodeData, { style: 'form' });
    }

    return this.http
      .request(
        rb.build({
          responseType: 'json',
          accept: 'application/json',
          context: params?.context,
        }),
      )
      .pipe(
        filter((r: any) => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<QrCodeUserInfoModel>;
        }),
      );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getUserInfoFromQrCode$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserInfoFromQrCode(params?: { qrCodeData?: string; context?: HttpContext }): Observable<QrCodeUserInfoModel> {
    return this.getUserInfoFromQrCode$Response(params).pipe(
      map((r: StrictHttpResponse<QrCodeUserInfoModel>) => r.body as QrCodeUserInfoModel),
    );
  }
}
